var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.icon === 'exercise')?_c('ExerciseIcon'):_vm._e(),(_vm.icon === 'video')?_c('VideoIcon'):_vm._e(),(_vm.icon === 'material')?_c('MaterialIcon'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }